// extracted by mini-css-extract-plugin
module.exports = {"Link":"Link-module--Link--24MGY"};